import { Box } from '@breathelife/mui';
import { ReactElement } from 'react';

import { RenderingField } from '@zinnia/form-engine-sdk';
import { Text } from '@breathelife/ui-components';

import { hasValidChildFields, replaceHtmlTag } from '../../Helpers';
import { BaseFieldProps } from '../FieldGenerator/FieldGenerator';
import { Field } from './Field';
import { QuestionContainer } from './Styles';

export type SummaryQuestionProps = BaseFieldProps & {
  stepId: string;
  onEditClick: (stepId: string) => void;
};

export function SummaryQuestion(props: SummaryQuestionProps): ReactElement | null {
  const { fieldGroup, stepId } = props;

  if (!fieldGroup.visible || !hasValidChildFields(fieldGroup)) return null;

  return (
    <QuestionContainer mb={3}>
      <Box>
        {fieldGroup.title && (
          <Box my={3}>
            <Text variant='small-body' grey={90}>
              {replaceHtmlTag(fieldGroup.title, 'strong', 'span')}
            </Text>
          </Box>
        )}
        {fieldGroup.fields.map((field: RenderingField) => (
          <Field {...props} key={field.id} field={field} stepId={stepId} />
        ))}
      </Box>
    </QuestionContainer>
  );
}
